export default __webpack_public_path__ + "static/img3-0f7abfce597ba3e00be1448dcbdfbd10.png";